/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import Topheader from "../../../Layout/header/header";
import "../Documentation/documentation.css";

const Codelab = () => {
  return (
    <div className="appListContainerDoc">
      <Topheader />

      <iframe
        title="codelab"
        className="doc"
        src="https://developer-docs.eks-store-qa.store.ignite.aws.harmandev.com/codelab/"
       style={{ border: "none" }}
      ></iframe>
    </div>
  );
};

export default Codelab;
